<template>
  <section class="info-list">
    <div class="info-panel">
      <div class="contain-head">
        <div class="container-head-title">
          <i
            class="icon-laba iconfont"
            style="color: #f3a954;font-size: 30px"
          ></i>
          <span
            class="subpage-head-text"
            style="margin-top: -5px;position: absolute;padding-left: 5px;"
            >{{ title }}</span
          >
          <div style="float: right">
            <common-button
              size="default"
              type="cancel"
              image
              @click="handleBackClick()"
              >返回</common-button
            >
          </div>
        </div>
      </div>

      <div class="container-body">
        <el-row>
          <div style="float: right">
            <common-button
              v-if="this.editFlag"
              size="small"
              type="cancel"
              image
              @click="bulkImport"
              style="margin-left: 5px"
              >批量导入</common-button
            >
            <common-button
              v-if="this.editFlag"
              size="small"
              type="cancel"
              slot="expand"
              @click="templateDown('/static/files/Huizhen_FileUpload.xlsx')"
              style="margin-left: 5px"
              >模板下载</common-button
            >
          </div>
        </el-row>
        <div class="form-body">
          <div class="table-card">
            <el-form :model="form" :rules="huizhenRules" ref="ruleForm">
              <el-table
                ref="table"
                v-loading="tableData.isLoading"
                :data="tableData.list"
                tooltip-effect="dark"
                highlight-current-row
                size="mini"
                style="width: 100%;"
              >
                <el-table-column
                  align="center"
                  label="序号"
                  width="70"
                  prop="index"
                  sortable
                >
                  <template slot-scope="scope">
                    <div class="index">{{ scope.$index + 1 }}</div>
                  </template>
                </el-table-column>

                <el-table-column
                  label="会诊邀请单位"
                  :min-width="200"
                  prop="inviteUnit"
                  sortable
                >
                  <template slot-scope="scope">
                    <el-form-item
                      :style="{
                        'margin-bottom':
                          scope.$index == globalIndex ? '23px' : '0px'
                      }"
                      prop="inviteUnit"
                    >
                      <el-input
                        v-if="!scoreEditFlag && scope.$index == globalIndex"
                        v-model="form.inviteUnit"
                        clearable
                        placeholder="请输入"
                      >
                      </el-input>
                      <span
                        v-else
                        class="twoLineCls"
                        :title="scope.row.inviteUnit"
                        >{{ scope.row.inviteUnit }}</span
                      >
                    </el-form-item>
                  </template>
                </el-table-column>

                <el-table-column
                  label="会诊时间"
                  :min-width="globalIndex != null ? 160 : 100"
                  prop="beginDate"
                  sortable
                >
                  <template slot-scope="scope">
                    <el-form-item
                      :style="{
                        'margin-bottom':
                          scope.$index == globalIndex ? '23px' : '0px'
                      }"
                      prop="beginDate"
                    >
                      <el-date-picker
                        v-if="!scoreEditFlag && scope.$index == globalIndex"
                        type="date"
                        v-model="form.beginDate"
                        :picker-options="startPickerOptions"
                        clearable
                        style="width: 100%"
                        placeholder="请选择"
                      >
                      </el-date-picker>
                      <span v-else class="twoLineCls">{{
                        scope.row.beginDate | dateFormat
                      }}</span>
                    </el-form-item>
                  </template>
                </el-table-column>

                <el-table-column
                  label="会诊患者简介（姓名、性别、诊断、诊疗内容等）"
                  min-width="300"
                  prop="patientDesc"
                  sortable
                >
                  <template slot-scope="scope">
                    <el-form-item
                      :style="{
                        'margin-bottom':
                          scope.$index == globalIndex ? '23px' : '0px'
                      }"
                      prop="patientDesc"
                    >
                      <el-input
                        v-if="!scoreEditFlag && scope.$index == globalIndex"
                        v-model="form.patientDesc"
                        type="textarea"
                        clearable
                        placeholder="请输入"
                      >
                      </el-input>
                      <span
                        v-else
                        class="twoLineCls"
                        :title="scope.row.patientDesc"
                        >{{ scope.row.patientDesc }}</span
                      >
                    </el-form-item>
                  </template>
                </el-table-column>

                <el-table-column
                  width="120"
                  label="评分"
                  v-if="!editFlag"
                  prop="score"
                  sortable
                >
                  <template slot-scope="scope">
                    <el-form-item
                      :style="{
                        'margin-bottom':
                          scope.$index == globalIndex ? '23px' : '0px'
                      }"
                      prop="score"
                    >
                      <el-input
                        v-if="scope.$index == globalIndex"
                        v-model="form.score"
                        clearable
                        placeholder="请输入"
                      >
                      </el-input>
                      <span
                        v-else
                        class="twoLineCls"
                        :title="scope.row.score"
                        >{{ scope.row.score }}</span
                      >
                    </el-form-item>
                  </template>
                </el-table-column>

                <el-table-column
                  align="center"
                  label="附件"
                  prop=""
                  sortable
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <div style="overflow-x: auto;width: 100%">
                      <span
                        v-if="!scoreEditFlag && scope.$index == globalIndex"
                      >
                        <div
                          v-for="(item, index) of form.attachIds"
                          :key="index"
                          class="attachment-original-name"
                        >
                          <a
                            @click="
                              preViewAttachment(item, index, scope.$index)
                            "
                            style="cursor: pointer"
                            >{{ item.attachmentOriginalName }}</a
                          >
                          <el-button
                            style="border:0px !important;cursor: pointer;"
                            type="text"
                            size="small"
                            class="el-icon-close"
                            @click="removeAttachment(scope.$index, index)"
                          ></el-button>
                        </div>
                      </span>
                      <span v-else>
                        <div
                          v-for="(item, index) of scope.row.attachIds"
                          :key="index"
                          class="attachment-original-name"
                        >
                          <a
                            @click="
                              preViewAttachment(item, index, scope.$index)
                            "
                            style="cursor: pointer"
                            >{{ item.attachmentOriginalName }}</a
                          >
                        </div>
                      </span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="this.editFlag || this.scoreEditFlag"
                  align="center"
                  prop=""
                  label="操作"
                  width="180"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <!--上传附件-->
                    <el-button
                      v-if="scope.$index == globalIndex"
                      style="border:0px !important;"
                      type="text"
                      size="small"
                      @click="dialogVisible = true"
                      >上传附件
                    </el-button>
                    <!--编辑-->
                    <el-button
                      style="border:0px !important;"
                      type="text"
                      size="small"
                      v-if="scope.$index != globalIndex"
                      @click="handleEditClick(scope.row, scope.$index)"
                      >编辑</el-button
                    >
                    <!--删除-->
                    <el-button
                      style="border:0px !important;"
                      type="text"
                      size="small"
                      v-if="scope.$index != globalIndex"
                      @click="handleDeleteClick(scope.row, scope.$index)"
                      >删除</el-button
                    >
                    <!--保存-->
                    <el-button
                      style="border:0px !important;"
                      type="text"
                      size="small"
                      v-if="scope.$index == globalIndex"
                      @click="handleSaveClick(scope.row, scope.$index, true)"
                      >保存</el-button
                    >
                    <!--取消-->
                    <el-button
                      style="border:0px !important;"
                      type="text"
                      size="small"
                      v-if="scope.$index == globalIndex"
                      @click="handleCancelClick(scope.row, scope.$index)"
                      >取消</el-button
                    >
                  </template>
                </el-table-column>
                <div
                  v-if="
                    (globalIndex != null
                      ? tableData.list[globalIndex].id
                      : true) && this.editFlag
                  "
                  slot="append"
                  style="height: 40px;text-align: center;margin: auto;font-size: 20px;padding: 8px;color: #34c5e7; cursor: pointer"
                  @click="handleAddClick()"
                >
                  <!--在此处添加你想要插入在表格最后一行的内容-->
                  <span>+</span>
                </div>
              </el-table>
            </el-form>
          </div>
          <span style="float: right">
            <el-pagination
              layout="sizes, prev, pager, next"
              :total="tableData.total"
              :page-size="tableData.pageSize"
              :page-sizes="tableData.pageSizeArray"
              @current-change="handlePageChange"
              @size-change="handleSizeChange"
              :current-page="tableData.pageNum"
            >
            </el-pagination>
          </span>
        </div>
      </div>
    </div>

    <!--批量导入弹窗-->
    <el-dialog
      style="text-align: center"
      title="请导入数据(该操作将刷新页面，请先保存已编辑数据)"
      :visible.sync="drawerVisible"
    >
      <el-upload
        class="upload-demo"
        drag
        action
        :multiple="false"
        :http-request="fileUpload"
        :file-list="showFileList"
        :limit="1"
        accept=".xls,.xlsx"
        :before-upload="beforeUploadImport"
        :on-exceed="handleExceed"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或<em style="color:#5ed5d9;">点击上传</em>
        </div>
        <div class="el-upload__tip" slot="tip">仅支持xls/xlsx文件</div>
      </el-upload>

      <el-button
        style="margin-top: 20px"
        type="primary"
        size="small"
        @click="saveHuizhenByFile"
        :loading="fileSaveBtnLoading"
      >
        保存数据
      </el-button>
    </el-dialog>

    <!--批量导入错误数据弹窗-->
    <el-dialog
      style="text-align: center;"
      :title="'批量错误数据提示(共' + errorData.huizhens.length + '行)'"
      class="error-dialog"
      custom-class="error-dialog"
      :close-on-click-modal="false"
      :visible.sync="errorDataVisible"
      @close="errorDialogClose"
    >
      <div style="height:100%;overflow-y: auto">
        <el-table
          :data="errorData.huizhens"
          tooltip-effect="dark"
          highlight-current-row
          height="100%"
          size="mini"
          style="width: 100%;"
        >
          <el-table-column
            align="center"
            label="行号"
            width="50"
            prop="lineNo"
          ></el-table-column>
          <el-table-column
            label="会诊邀请单位"
            prop="inviteUnit"
          ></el-table-column>
          <el-table-column
            align="center"
            label="会诊日期"
            prop="bDate"
          ></el-table-column>
          <el-table-column
            label="会诊患者简介（姓名、性别、诊断、诊疗内容等）"
            prop="patientDesc"
          ></el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <div class="demo-image__preview">
      <el-image ref="previewImg" :preview-src-list="attachment.attachmentsLink">
      </el-image>
    </div>

    <animation
      :loadingDataVisible="loadingDataVisible"
      :loadingText="loadingText"
    ></animation>
    <!-- 附件预览弹窗 -->
    <dialog-preview
      :preViewObj="preViewObj"
      :showPreview="showPreview"
      @handleClosePreview="showPreview = false"
    />
    <!-- 附件搜索 -->
    <historical-attachment
      :dialogVisible.sync="dialogVisible"
      @AddAttachment="AddAttachment"
    />
  </section>
</template>

<script>
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import { mapState } from "vuex";
import { Message } from "element-ui";
import animation from "@/components/loading/animation";
import {
  ATTA_UPLOAD_COMPONENT_TYPE_STR,
  ATTA_FILE_SHOW_TYPE,
  ATTA_FILE_DOWN_TYPE
} from "@/constants/constants";
import * as constantsRules from "@/constants/constantRules";
import { PAGE_SIZE_ARRAY } from "@/constants/constants";
export default {
  name: "ConsultatiionList",
  components: { animation },
  data() {
    return {
      loadingDataVisible: false, //是否显示加载动画
      title: "会诊",
      this_: this, //保存this以便filters中使用
      loadingText: null,
      form: {
        id: null,
        userId: "",
        inviteUnit: "",
        patientDesc: "",
        beginDate: "",
        score: null,
        attachIds: []
      },
      tableData: {
        //当前登录人
        userId: "",
        isLoading: false,
        pageNum: 1,
        pageSize: 10,
        currentPage: 1,
        pageSizeArray: PAGE_SIZE_ARRAY,
        list: [],
        total: 20
      },
      dialog: {
        editFlag: "view"
      },
      startPickerOptions: {
        disabledDate: t => {
          return t.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          }
        ]
      },
      border: true,
      addAttachIndex: "",
      //附件的允许上传的类型
      acceptAttachmentType: ATTA_UPLOAD_COMPONENT_TYPE_STR,
      acceptAttachmentShowType: ATTA_FILE_SHOW_TYPE,
      acceptAttachmentDownType: ATTA_FILE_DOWN_TYPE,
      attachmentsMultipart: [], //文件数组
      attachment: {
        attachmentsLink: [],
        //图片的类型后缀
        imagesType: ["jpg", "jpeg", "png", "gif"]
      },
      //附件的允许上传的类型
      huizhenRules: constantsRules.HuizhenRules,
      isEdit: false, //是否有东西在编辑
      isCreateButton: false, //是否出现新增按钮
      globalIndex: null, //学历信息的全局索引
      drawerVisible: false, //是否显示批量导入弹窗
      fileSaveBtnLoading: false, //保存数据动画
      isDelete: false,
      showPreview: false,
      dialogVisible: false,
      preViewObj: {},
      showFileList: [], //附件显示的列表
      errorDataVisible: false,
      errorData: {
        huizhens: []
      },
      editFlag: null,
      scoreEditFlag: null
    };
  },
  created() {
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
    }
    // 在页面刷新时将store保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  mounted() {
    this.editFlag =
      this.$store.state.MemberManageModule.userId == null &&
      !["view", "update"].includes(this.$store.state.MemberManageModule.type)
        ? true
        : false;
    this.scoreEditFlag =
      this.$store.state.MemberManageModule.userId != null &&
      this.$store.state.MemberManageModule.type == "update"
        ? true
        : false;
    this.queryData();
  },

  methods: {
    //规则校验
    validateFileForm() {
      let result = false;
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          result = true;
        }
      });
      return result;
    },

    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "";
      }
      let clzz = {
        background: "#F3FDFF" + "!important"
      };
      return clzz;
    },
    //返回
    handleBackClick() {
      this.onBack();
    },

    //分页
    handlePageChange(val) {
      this.tableData.pageNum = val;
      if (this.globalIndex != null) {
        this.warnDialog(null);
      } else {
        this.queryData();
      }
    },
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      if (this.globalIndex != null) {
        this.warnDialog(null);
      } else {
        this.queryData();
      }
    },
    closeDialog() {
      // this.dialog.isShow = false;
      this.dialog.editFlag = "view";
    },
    handleClickSearch() {
      this.tableData.pageNum = 1;
      this.queryData();
    },
    queryData(flag) {
      this.loadingDataVisible = true;
      http
        .post(
          window.config.api.baseUrl + "/eims-api/personal/data/getHuizhenList",
          {
            token: cookie.getCookie("token"),
            data: {
              pageNum: this.tableData.pageNum,
              pageSize: this.tableData.pageSize,
              userId: this.$store.state.MemberManageModule.userId
            }
          }
        )
        .then(response => {
          if (response.data.code === "00000") {
            let obj = null;
            if (flag) {
              obj = JSON.parse(
                JSON.stringify(
                  this.tableData.list[this.tableData.list.length - 1]
                )
              );
            }
            this.tableData.list = response.data.data.eimsSzyHuizhens;
            this.tableData.total = response.data.data.total;
            if (obj) {
              this.form = JSON.parse(JSON.stringify(obj));
              this.tableData.list.push(obj);
              this.globalIndex = this.tableData.list.length - 1;
            }
          }
        })
        .finally(() => {
          this.loadingDataVisible = false;
        });
    },

    //编辑操作
    handleEditClick(row, index) {
      if (this.globalIndex != null) {
        this.warnDialog(row, index);
      } else {
        this.globalIndex = index;
        this.form = JSON.parse(JSON.stringify(row));
      }
    },

    //删除操作
    handleDeleteClick(row, index) {
      let that = this;
      let deleteIndex = index;
      that
        .$confirm("确定将帮扶单位名称为" + row.helpUnit + "的数据删除？", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          if (row.id) {
            this.loadingDataVisible = true;
            let token = cookie.getCookie("token");
            http
              .post(
                window.config.api.baseUrl +
                  "/eims-api/personal/data/deleteHuizhenInfo",
                {
                  token: token,
                  data: {
                    id: row.id
                  }
                }
              )
              .then(response => {
                if (response.data.code == "00000") {
                  Message.success("删除成功");
                  this.isDelete = true;
                  if (deleteIndex == this.globalIndex) {
                    this.globalIndex = null;
                  } else if (deleteIndex < this.globalIndex) {
                    if (this.globalIndex != this.tableData.list.length - 1) {
                      this.globalIndex = this.globalIndex - 1;
                    }
                  }
                  this.queryData(
                    this.globalIndex == this.tableData.list.length - 1 ? 1 : 0
                  );
                }
              })
              .finally(() => {
                this.isDelete = false;
                this.loadingDataVisible = false;
              });
          }
        })
        .catch(() => {});
    },

    //保存操作
    handleSaveClick(row, index, flag) {
      if (!this.validateFileForm()) {
        Message.warning("编辑框校验不通过，请检查其内容！");
        return false;
      }
      if (this.scoreEditFlag) {
        this.loadingDataVisible = true;
        http
          .post(
            window.config.api.baseUrl +
              "/eims-api/personal/score/editHuizhenInfo",
            {
              token: cookie.getCookie("token"),
              data: {
                id: row.id,
                score: (this.form.score ? this.form.score : 0) + ""
              }
            }
          )
          .then(response => {
            if ((response.data.code = "00000")) {
              Message.success("修改成功!");
              this.queryData();
              if (flag) {
                this.globalIndex = null;
                this.form = this.$options.data().form;
              } else {
                if (index > this.globalIndex) {
                  this.globalIndex = index;
                } else {
                  this.globalIndex = index + 1;
                }
                this.form = JSON.parse(JSON.stringify(row));
              }
              this.attachmentsMultipart = [];
            }
          })
          .finally(() => {
            this.loadingDataVisible = false;
          });
        return;
      }
      Message.info("数据导入可能需要几分钟,请耐心等待");
      let that = this;
      // 使用form表单的数据格式
      const paramsData = new FormData();
      // 将上传文件数组依次添加到参数paramsData中
      this.attachmentsMultipart.forEach((it, index) => {
        paramsData.append(`file`, it.file);
      });
      if (this.attachmentsMultipart.length === 0) {
        paramsData.append(`file`, null);
      }
      let jsonData = {
        token: cookie.getCookie("token"),
        data: {
          attachment: this.form.attachIds,
          eimsHuizhen: {
            id: this.form.id,
            userId: this.form.userId,
            inviteUnit: this.form.inviteUnit,
            patientDesc: this.form.patientDesc,
            beginDate: this.form.beginDate
              ? this.moment(this.form.beginDate).format("YYYY-MM-DD")
              : null
          }
        }
      };
      //将表单数据添加到参数paramsData中,需要将参数转化成Blob后端才能识别到文件
      paramsData.append(
        "data",
        new Blob([JSON.stringify(jsonData)], { type: "application/json" })
      );
      // 表单数据和文件一起上传,调用后端接口
      this.loadingDataVisible = true;
      http
        .post(
          window.config.api.baseUrl + "/eims-api/personal/data/editHuizhenInfo",
          paramsData
        )
        .then(response => {
          if (response.data.code === "00000") {
            if (row.id) {
              Message.success("保存成功!");
            } else {
              Message.success("新增成功!");
            }
            this.queryData();
            if (flag) {
              this.globalIndex = null;
              this.form = this.$options.data().form;
            } else {
              if (index > this.globalIndex) {
                this.globalIndex = index;
              } else {
                this.globalIndex = index + 1;
              }
              this.form = JSON.parse(JSON.stringify(row));
            }
            this.attachmentsMultipart = [];
          }
        })
        .finally(() => {
          that.loadingDataVisible = false;
        });
    },

    //取消操作
    handleCancelClick(row, index) {
      if (!row.id) {
        this.tableData.list.splice(this.tableData.list.length - 1, 1);
      }
      this.globalIndex = null;
      Object.assign(this.$data.form, this.$options.data().form);
      this.attachmentsMultipart = [];
    },

    //新增操作
    handleAddClick() {
      if (this.globalIndex != null) {
        this.warnDialog();
      } else {
        this.tableData.list.push(this.form);
        this.globalIndex = this.tableData.list.length - 1;
      }
    },

    warnDialog(row, index) {
      const h = this.$createElement;
      this.$confirm("提示", {
        message: h("p", null, [
          h(
            "p",
            { style: "font-size: 18px;line-height: 40px;" },
            "有内容没有保存，是否保存并退出编辑？"
          ),
          h(
            "p",
            { style: "font-size: 14px;color: #00000069;" },
            "放弃修改，更新的内容不会自动保存"
          )
        ]),
        distinguishCancelAndClose: true,
        confirmButtonText: "保存",
        cancelButtonText: "放弃修改",
        type: "warning"
      })
        .then(() => {
          this.handleSaveClick(row, index);
        })
        .catch(action => {
          if (action !== "cancel") return;
          /* 点击编辑按钮时 */
          if (row) {
            if (!this.tableData.list[this.globalIndex].id) {
              /* 第一种情况 正在新增时，点击其它的编辑按钮 */
              this.tableData.list.splice(this.tableData.list.length - 1, 1);
            }
            /* 第二种情况 正在编辑时,点击其它的编辑按钮*/
            this.globalIndex = index;

            this.form = JSON.parse(JSON.stringify(row));
            this.form.beginDate = new Date(this.form.beginDate);
            this.form.endDate = new Date(this.form.endDate);
          } else {
            if (row != undefined) {
              this.globalIndex = null;
              Object.assign(this.$data.form, this.$options.data().form);
              this.queryData();
            } else {
              /* 第三种情况 正在编辑时,点击新增按钮时 */
              this.globalIndex = this.tableData.list.length;
              Object.assign(this.$data.form, this.$options.data().form);
              this.tableData.list.push(this.form);
            }
          }
          this.attachmentsMultipart = [];
        });
    },

    //上传之前的判断
    handleBeforeUpload(file) {
      let testMsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (!this.acceptAttachmentType.includes(testMsg)) {
        this.$message({
          message: "上传附件类型不合法！",
          type: "warning",
          showClose: true
        });
        return false;
      } else {
        const localUrl = URL.createObjectURL(
          new Blob([file], { type: file.type })
        );
        this.form.attachIds.push({
          attachmentOriginalName: file.name,
          localUrl
        });
      }
    },

    //添加附件
    attachmentUpload(file, fileList, index) {
      this.attachmentsMultipart.push(file);
    },

    //移除附件
    removeAttachment(listIndex, index) {
      if (!this.form.attachIds[index].id) {
        this.attachmentsMultipart.splice(index, 1);
      }
      this.form.attachIds.splice(index, 1);
    },
    //点击查看按钮
    preViewAttachment(item) {
      this.preViewObj = item;
      if (item.localUrl) {
        this.preViewObj.url = item.localUrl;
      } else {
        this.preViewObj.url =
          window.config.api.baseUrl +
          "/eims-api/attachment/findFile?token=" +
          cookie.getCookie("token") +
          "&code=" +
          item.code;
      }
      this.showPreview = true;
    },

    //准备需要查看的附件的链接,然后显示或者下载附件
    handleView(item) {
      let fileType = item.attachmentOriginalName.substring(
        item.attachmentOriginalName.lastIndexOf(".") + 1
      );
      const elink = document.createElement("a");
      http
        .get(
          window.config.api.baseUrl +
            "/eims-api/attachment/findFile?token=" +
            cookie.getCookie("token") +
            "&code=" +
            item.code,
          { responseType: "blob" }
        )
        .then(response => {
          if (response) {
            let attaFileDownTypeElement = this.acceptAttachmentDownType[
              fileType
            ];
            elink.download = item.attachmentOriginalName.substring(
              0,
              item.attachmentOriginalName.lastIndexOf(".")
            );
            elink.style.display = "none";
            elink.target = "_blank";
            elink.href = URL.createObjectURL(
              new Blob([response.data], { type: attaFileDownTypeElement })
            );
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href);
            document.body.removeChild(elink);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //批量导入
    bulkImport() {
      if (!this.fileSaveBtnLoading) {
        this.showFileList = [];
        this.fileList = [];
      }
      this.drawerVisible = true;
    },

    //导入模板下载
    templateDown(fileName) {
      const a = document.createElement("a");
      a.href = fileName;
      a.download = "会诊信息模板.xlsx";
      a.target = "_blank";
      a.click();

      // var pathName=window.document.location.pathname;
      // var projectName=pathName.substring(0,pathName.substr(1).indexOf('/')+1);
      // return 'http://' + window.location.host + projectName + fileName
    },

    fileUpload(file, fileList) {
      //由于组件可能存在问题 ,直接共用一个list会出现选择文件之后文件列表不显示文件名的情况
      //所以需要定义两个,一个用于显示文件名,一个用于接受文件
      this.showFileList = [];
      this.fileList = [];
      let fileInfo = {
        name: file.file.name
      };
      this.fileList.push(file);
      this.showFileList.push(fileInfo);
    },

    // 批量导入之前判断类型
    beforeUploadImport(file) {
      let testMsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension1 = testMsg === "xls";
      const extension2 = testMsg === "xlsx";
      if (!extension1 && !extension2) {
        this.$message({
          message: "上传文件只能是xls或xlsx格式！",
          type: "warning"
        });
        return false;
      } else {
        return true;
      }
    },

    handleExceed(files, fileList) {
      Message.warning({ message: `只允许上传一个文件`, showClose: true });
    },

    saveHuizhenByFile() {
      if (this.showFileList.length === 0) {
        Message.error({ message: "请先选择上传的文件", showClose: true });
        return;
      }
      if (this.showFileList.length !== 1) {
        Message.error({ message: "一次只允许上传一个文件", showClose: true });
        return;
      }
      // 使用form表单的数据格式
      const paramsData = new FormData();
      // 将上传文件数组依次添加到参数paramsData中
      this.fileList.forEach((it, index) => {
        paramsData.append(`file`, it.file);
      });
      let jsonData = {
        token: cookie.getCookie("token")
      };
      // Message.info("数据导入可能需要几分钟,请耐心等待")
      //将表单数据添加到参数paramsData中,需要将参数转化成Blob后端才能识别到文件
      paramsData.append(
        "data",
        new Blob([JSON.stringify(jsonData)], { type: "application/json" })
      );
      // Message.success("数据导入成功");
      // this.drawerVisible = false
      // 表单数据和文件一起上传,调用后端接口
      // this.fileSaveBtnLoading = true
      this.loadingDataVisible = true;
      http
        .post(
          window.config.api.baseUrl +
            "/eims-api/personal/data/uploadHuizhenInfo",
          paramsData
        )
        .then(response => {
          if (response.data.code === "00000") {
            let data = response.data.data;
            Message.success("会诊信息批量导入操作完成");
            this.globalIndex = null;
            Object.assign(this.$data.form, this.$options.data().form);
            this.queryData();
            if (data.total != 0) {
              this.errorData.huizhens = data.eimsSzyHuizhens;
              this.errorDataVisible = true;
            }
          }
        })
        .finally(() => {
          this.loadingDataVisible = false;
          this.drawerVisible = false;
        });
    },

    errorDialogClose() {
      Object.assign(this.$data.errorData, this.$options.data().errorData);
    },

    // 监听返回按钮的处理函数
    onBack() {
      if (this.globalIndex != null) {
        const h = this.$createElement;
        this.$confirm("提示", {
          message: h("p", null, [
            h(
              "p",
              { style: "font-size: 18px;line-height: 40px;" },
              "有内容没有保存，是否保存并退出编辑？"
            ),
            h(
              "p",
              { style: "font-size: 14px;color: #00000069;" },
              "放弃修改，更新的内容不会自动保存"
            )
          ]),
          distinguishCancelAndClose: true,
          confirmButtonText: "保存",
          cancelButtonText: "放弃修改",
          type: "warning"
        })
          .then(() => {
            if (!this.validateFileForm()) {
              Message.warning("编辑框校验不通过，请检查其内容！");
              return;
            }
            this.handleSaveClick(this.form, this.globalIndex);
            this.$router.go(-1);
          })
          .catch(action => {
            if (action === "cancel") {
              this.globalIndex = null;
              this.$router.go(-1);
            } else {
              history.pushState(null, null, document.URL);
            }
          });
      } else {
        this.$router.go(-1);
      }
    },
    AddAttachment(files, attachmentsMultipart) {
      if (attachmentsMultipart)
        this.attachmentsMultipart.push(...attachmentsMultipart);

      files.forEach(item => {
        if (item.uid) {
          item.localUrl = item.url;
        }
        this.form.attachIds.push(item);
      });
    }
  },
  computed: {
    ...mapState({
      userPower: state => state.userPowerStore.userPower
    })
  },

  watch: {
    userPower: {
      immediate: true,
      handler(newVal) {
        this.superPower = this.$store.state.userPowerStore.superPower;
        this.unApproveMember = this.$store.state.userPowerStore.unApproveMember;
      }
    },

    "data.list.length": {
      handler(newVal, oldVal) {
        if (newVal < oldVal) {
          if (oldVal === 1) {
            if (this.data.pageNum !== 1) {
              this.handlePageChange(this.data.pageNum - 1);
            } else {
              this.handlePageChange(1);
            }
          }
        }
      }
    },
    globalIndex(newVal, oldVal) {
      if (this.isDelete) return;
      this.$refs["ruleForm"].resetFields();
    }
  }
};
</script>

<style lang="scss" scoped>
.info-list {
  height: calc(100vh - 109px);
  margin: 20px;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 1px 2px 5px #ccc;
  .info-panel {
    .contain-head {
      border-bottom: 1px solid #f5f5f5;
      padding: 10px;
      line-height: 20px;
      overflow: auto;
    }
    .contain-body {
      padding: 10px;
      .form-body {
        .table-card {
          .attachment-original-name:hover {
            color: #2866e3;
            text-decoration: underline;
          }
          .twoLineCls {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
      }
    }
  }
}

/deep/.el-form-item {
  margin-bottom: 0px;
}

/deep/ .el-table .el-table__cell {
  vertical-align: top;
}

/deep/ .el-form-item__content {
  line-height: 23px;
}

/deep/ .el-table .cell {
  white-space: unset;
}

/deep/ .el-image__error {
  display: none;
}

/deep/ .error-dialog .el-dialog__body {
  overflow-y: auto;
  height: calc(100vh - 15vh - 150px);
}
/deep/ .el-dialog.error-dialog {
  width: 70%;
}
</style>



// WEBPACK FOOTER //
// src/pages/privateplot/memberDataList/memberSocialInfluence/ConsultatiionList.vue